import moment from 'moment-timezone';

export const buildSaleListRequest = (query = {}, requiredParams = {}) => {
  const rawParams = query.params ? { ...query.params } : { ...query };

  if (rawParams.cursor != null && rawParams.cursor !== '') {
    // Admin Sales V2 cursors are opaque and inherit the original filters and
    // page size. The backend contract requires cursor requests to send only
    // the cursor value.
    return {
      config: { params: { cursor: rawParams.cursor } },
      append: true
    };
  }

  const initialParams = { ...rawParams };
  delete initialParams.page;
  delete initialParams.cursor;
  return {
    config: { params: { ...initialParams, ...requiredParams } },
    append: false
  };
};

export const mergeSaleListResponse = (payload = {}, currentList = {}, append = false) => {
  const nextData = Array.isArray(payload.data) ? payload.data : [];
  const currentData = Array.isArray(currentList.data) ? currentList.data : [];

  return {
    ...payload,
    data: append ? [...currentData, ...nextData] : nextData,
    has_more: Boolean(payload.has_more),
    next_cursor: payload.next_cursor == null ? null : payload.next_cursor
  };
};

const JAKARTA = 'Asia/Jakarta';
const RTS_WALL_TIME = 'YYYY-MM-DD HH:mm:ss';

export const MARKETPLACE_SHIPPING_LABELS = {
  STANDARD: 'Standard',
  INSTANT: 'Instant',
  INSTANT_PRIORITAS: 'Instant Prioritas',
  SAMEDAY: 'Same Day',
};

export const getMarketplaceShippingMethod = (sale = {}) => (
  sale.tiktok_shipping_method || sale.shopee_shipping_method || null
);

export const formatMarketplaceShippingLabel = (method) => {
  if (method == null || method === '') return null;
  return MARKETPLACE_SHIPPING_LABELS[method] || method;
};

export const getMarketplaceShippingLabel = (sale = {}) => (
  formatMarketplaceShippingLabel(getMarketplaceShippingMethod(sale))
);

export const getMarketplaceRtsExpiresAt = (sale = {}) => (
  sale.tiktok_rts_expires_at || sale.shopee_rts_expires_at || null
);

export const RTS_OVERDUE_LABEL = 'RTS overdue';

export const parseJakartaWallTime = (value) => {
  if (value == null || value === '') return null;
  const parsed = moment.tz(String(value), [RTS_WALL_TIME, moment.ISO_8601], true, JAKARTA);
  if (!parsed.isValid()) {
    console.warn('Unparseable RTS deadline', value);
    return null;
  }
  return parsed;
};

const padClock = (value) => String(value).padStart(2, '0');

export const isRtsCountdownActive = (expiresAt, now = moment()) => {
  const label = formatRtsCountdown(expiresAt, now);
  return label != null && label !== RTS_OVERDUE_LABEL;
};

// Confirm Pickup stays closed until marketplace tracking has an AWB. A running
// countdown is the usual reason that number is missing, and it is not required
// for the gate: overdue and unset deadlines stay closed too.
export const isConfirmPickupDisabled = ({ hasAwb } = {}) => !hasAwb;

export const formatRtsCountdown = (expiresAt, now = moment()) => {
  const deadline = moment.isMoment(expiresAt) ? expiresAt : parseJakartaWallTime(expiresAt);
  if (deadline == null || !deadline.isValid()) return null;

  const remainingMs = deadline.valueOf() - now.valueOf();
  if (remainingMs <= 0) return RTS_OVERDUE_LABEL;

  const totalSeconds = Math.floor(remainingMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `RTS ${padClock(hours)}:${padClock(minutes)}:${padClock(seconds)}`;
};
